import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import { useFormik } from "formik";
import {
  // AddBrandlogo,
  // getAllBrandlogoData,
  getUserProfileDetail,
} from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";
import { setProfileData } from "../../redux/actions/profileAction";
// import { ProfileSettingSchema } from "../../schema";

// const initialValues = {
//   // ProfileDetails
//   image: "",
// };

const ProfileSetting = ({ id }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { profileData, token } = useSelector((state) => state.profileReducer);
  const toast = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  // const handleImageUpload = (e, setImage) => {

  //   if (e.target.files.length) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       const convertImage = convertBase64ToImage(reader.result)
  //       setPreviewImg(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const getProfileManagement = async () => {
    setIsLoading(true);
    getUserProfileDetail(token)
      .then((res) => {
        dispatch(setProfileData(res?.data?.result));
        setIsLoading(false);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    async function getAllAPI() {
      await getProfileManagement();
      // await getBrandLogo();
    }
    getAllAPI();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onEditHandler = async (id) => {
    navigate(`/profile-setting/EditProfile?userId=${id}`);
  };

  // const handleImageUpload = (event, setImage) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     setImage(file);
  //     setFieldValue("image", file);
  //   }
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       const convertImage = convertBase64ToImage(reader.result);
  //       setImg(convertImage);
  //       setImage(convertImage);
  //       setPreviewImg(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  // const convertBase64ToImage = (uri) => {
  //   const splitDataURI = uri.split(",");
  //   const byteString =
  //     splitDataURI[0].indexOf("base64") >= 0
  //       ? atob(splitDataURI[1])
  //       : decodeURI(splitDataURI[1]);
  //   const type = splitDataURI[0].split(":")[1].split(";")[0];

  //   const ia = new Uint8Array(byteString.length);
  //   for (let i = 0; i < byteString.length; i += 1)
  //     ia[i] = byteString.charCodeAt(i);

  //   const imageBlob = new Blob([ia], { type });
  //   const imageFile = new File([imageBlob], "live-pic.jpeg", { type });

  //   return imageFile;
  // };

  // const addBrandLogoHandler = async (values) => {
  //   const formData = new FormData();
  //   formData.append("image", values.image);
  // };

  // const onBrandLogoAdd = async () => {
  //   // const img = await convertBase64ToImage(image1);
  //   const formData = new FormData();
  //   formData.append("brandLogo", img);
  //   await AddBrandlogo(formData, token)
  //     .then((res) => {
  //       setIsLoading(true);
  //       toast.current.show({
  //         severity: "success",
  //         summary: `${res?.data?.message}`,
  //       });
  //       setTimeout(() => {
  //         setIsLoading(false);
  //       }, 1000);
  //     })
  //     .catch((err) => {
  //       setIsLoading(false);
  //       toast.current.show({
  //         severity: "error",
  //         summary: `${err?.response?.data?.message}`,
  //       });
  //     });
  // };
  // const getBrandLogo = async () => {
  //   setIsLoading(true);
  //   getAllBrandlogoData(token).then((res) => {
  //     setPreviewImg(res?.data?.result[0].image);
  //     // setImage1(res?.data?.result[0].image);
  //     setIsLoading(false);
  //   });
  // };

  // const {
  //   // values,
  //   // errors,
  //   // handleChange,
  //   // handleSubmit,
  //   // touched,
  //   // setFieldValue,
  //   // setFieldTouched,
  //   // handleBlur,
  // } = useFormik({
  //   validationSchema: ProfileSettingSchema(),
  //   onSubmit: (values, action) => (values, action),
  // });

  // const handleOnChange = (e) => {
  //   if (e.target.files.length) {
  //     setFieldValue('', e?.target?.files[0]);
  //   } else {
  //     setFieldValue('', values[e.target.name]);
  //   }
  // };

  // const onEditHandler = () => {
  //   navigate(`/news-management/editNews?newsId=${id}`);
  // };

  return (
    <>
      <Toast ref={toast} />

      {isLoading && (
        <div className="set-proper-line-in-all-page">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}
      <div className="all-padding-side">
        <div className="userprofile-pics mt-4">
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <svg
                width="32"
                height="24"
                viewBox="0 0 32 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                onClick={() => {
                  navigate(-1);
                }}
              >
                <path
                  d="M0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607L10.4853 22.6066C11.0711 23.1924 12.0208 23.1924 12.6066 22.6066C13.1924 22.0208 13.1924 21.0711 12.6066 20.4853L4.12132 12L12.6066 3.51472C13.1924 2.92893 13.1924 1.97919 12.6066 1.3934C12.0208 0.807611 11.0711 0.807611 10.4853 1.3934L0.93934 10.9393ZM2 13.5H32V10.5H2V13.5Z"
                  fill="black"
                />
              </svg>
              <h6 className="mb-0">Profile Settings</h6>
            </div>
            <div className="right-side-btn-add">
              <button
                type="button"
                onClick={() => onEditHandler(profileData?.id)}
                // onClick={() => {
                //   navigate("/profile-setting/EditProfile");
                // }}
                className="btn btn-primary edit-btn-cls"
              >
                Edit
              </button>
            </div>
          </div>
        </div>

        <div className="body-part-area-start-profile">
          <div className="row mt-4 align-items-center area-part-only-cls-add">
            <div className="col-lg-3">
              <div className="first-sideuser">
                <img
                  src={
                    profileData?.profile_pic
                      ? profileData?.profile_pic
                      : require("../../assets/defaultImg.png")
                  }
                  alt="profilepic"
                />
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="second-sideuser">
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>First Name</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">{profileData?.first_name}</h6>
                    </div>
                  </div>
                </div>
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Email</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">{profileData?.email}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="second-sideuser">
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Last Name</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">{profileData?.last_name}</h6>
                    </div>
                  </div>
                </div>
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Phone</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">
                        {profileData?.telephone ? profileData?.telephone : "-"}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-6">
              <div className="second-sideuser">
                <div className="first-portion mb-3">
                  <div className="title-name">
                    <label>Gender</label>
                    <div className="subtitle-names">
                      <h6 className="mb-0">
                        {profileData?.gender === "1"
                          ? "male"
                          : profileData?.gender === "2"
                          ? "female"
                          : profileData?.gender === "3"
                          ? "Non-Binary"
                          : "-"}
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-lg-4 position-relative">
                    <label className="my-2">Upload profile image</label>
                    <input
                      type="file"
                      name="uploadimg"
                      className="form-control"
                      accept="image/png, image/jpeg, image/jpg image/bmp"
                      id="exampleFormControlInput1"
                      placeholder="File Name"
                      // onBlur={handleBlur}
                      // value={values.uploadimg}
                      onChange={(e) =>
                        handleOnChange(
                          e
                        )
                      }
                    ></input>
                  </div> */}
          </div>

          {/* <div className="d-block mt-5">
            <div className="upload-preview-container">
              <form onSubmit={handleSubmit}>
                <div className="upload-button">
                  <h5 className="mb-0">
                    Brand Logo: <span className="required">{"250w X 50h"}</span>
                  </h5>
                  <input
                    type="file"
                    name="image"
                    accept="image/png, image/jpeg, image/jpg"
                    className="btn btn-primary change-event-photo w-100 set-to-auto-height"
                    placeholder="File Name"
                    onBlur={handleBlur}
                    onChange={(e) => handleImageUpload(e, setImage1)}
                  />
                  {errors.image && touched.image ? (
                    <p className="form-error">{errors.image}</p>
                  ) : null}
                </div>
              </form>

              <div className="image-preview2 mx-3">
                {previewImg && <img src={previewImg} alt="Preview 1" />}
              </div>

              <div className="add-btns-all-preview mt-4">
                <button
                  type="submit"
                  className="btn btn-primary fill_btn border-0"
                  onClick={() => {
                    onBrandLogoAdd(id);
                  }}
                >
                  Add
                </button>
              </div>
            </div>
          </div> */}

          <div className="row mt-4">
            <div className="col-lg-12">
              <div className="right-side-btn-add mt-4">
                <button
                  type="button"
                  onClick={() => {
                    navigate("/profile-setting/ChangePassword");
                  }}
                  className="btn btn-primary edit-btn-cls"
                >
                  Change Password
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfileSetting;
